export default "__VITE_ASSET__CCJ10KPx__"